import React from "react";
import CardholderBasicInformationLocalStateAdapter from "../../../../../pages/cardholder-basic-information/localStateAdapter";
import {
  ApplicationChapterId,
  ApplicationFlows,
  ApplicationFlowSteps,
} from "../types";
import ApplicationFlowProvider from "../applicationFlowContext";
import { CardholderLocalState } from "../../../../../pages/cardholder-basic-information/types";

interface AdditionalCaFlowProps {
  localState: CardholderLocalState;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}

const AdditionalCardApplicationLocalStepFlow = (
  props: AdditionalCaFlowProps,
): React.JSX.Element => {
  const { localState, triggerReload, setStep } = props;

  return (
    <ApplicationFlowProvider
      flow={ApplicationFlows.ADDITIONAL_BAA}
      activeChapter={ApplicationChapterId.Cardholder}
      setStep={setStep}
    >
      <CardholderBasicInformationLocalStateAdapter
        localState={localState}
        triggerReload={triggerReload}
      />
    </ApplicationFlowProvider>
  );
};

export default AdditionalCardApplicationLocalStepFlow;
